import {assert} from 'Asserts';
import {hslTupleToCSSAttr} from 'lib/Colors';

function getNavbarColor(): string | undefined {
  return window.bootstrap?.navbarColor;
}

export function isNavbarColored(): boolean {
  return getNavbarColor() !== '' && !window.impersonating;
}

/**
 * Returns the background styles for a navbar element.
 *
 * @param isActive {boolean} - True if the element is active.
 */
export function makeNavbarBackgroundStyles(isActive: boolean): React.CSSProperties {
  if (!isNavbarColored()) {
    return {};
  }
  const color = getNavbarColor();
  assert(color !== undefined, 'navbarColor should be defined on window.bootstrap, but is not');
  if (color === '') {
    return {backgroundColor: ''};
  }
  return {backgroundColor: hslTupleToCSSAttr(...(color.split(',') as [string, string, string]))};
}
